export const formatItem = (item) => {
  const formattedItem = {};
  for (const [key, value] of Object.entries(item)) {
    formattedItem[key] = value ? value : "--";
  }
  return formattedItem;
};
